import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const flux = keyframes`
  0%, 100% {
    text-shadow: 0 0 5px #00FFC6, 0 0 15px #00FFC6, 0 0 50px #00FFC6, 0 0 50px #00FFC6, 0 0 2px #B9FFE8, 2px 2px 3px #12E29C;
    color: #4BFFEF;
  }
  50% {
    text-shadow: 0 0 3px #00B58D, 0 0 7px #00B58D, 0 0 25px #00B58D, 0 0 25px #00B58D, 0 0 2px #00B58D, 2px 2px 3px #006A60;
    color: #63D3AE;
  }
`;

const eye = keyframes`
  0% {
    opacity: 0;
    transform: translateX(0)
  }
  5% {
    opacity: 0;
  }
  15% {
    opacity: 1;
    transform: translateX(0)
  }
  20% {
    transform: translateX(15px)
  }
  35% {
    transform: translateX(15px)
  }
  40% {
    transform: translateX(-15px)
  }
  60% {
    transform: translateX(-15px)
  }
  65% {
    transform: translateX(0)
  }
`;

const leaf = keyframes`
  0% {
    transform: scaleX(1);
  }
  5% {
    transform: scaleX(0.2);
  } 
  70% {
    transform: scaleX(0.2);
  }
  75% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(1);
  }
`;

const Wrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const Message = styled.div`
  font-size: 30px;
  color: #0d344a;
  font-weight: 500;
  position: absolute;
  top: 230px;
  left: 40px;
`;

const Message2 = styled.div`
  font-size: 18px;
  color: #0d344a;
  font-weight: 500;
  width: 360px;
  position: absolute;
  top: 280px;
  left: 40px;
`;

const Message3 = styled.div`
  font-size: 18px;
  color: #0d344a;
  font-weight: 500;
  width: 360px;
  position: absolute;
  top: 330px;
  left: 40px;
`;

const Container = styled.div`
  position: absolute;
  right: 10%;
`;

const Neon = styled.div`
  text-align: center;
  width: 300px;
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 90px;
  color: #5BE0B3;
  letter-spacing: 3px;
  text-shadow: 0 0 5px #6EECC1;
  animation: ${flux} 2s linear infinite;
`;

const DoorFrame = styled.div`
  height: 495px;
  width: 295px;
  border-radius: 90px 90px 0 0;
  background-color: #8594A5;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Door = styled.div`
  height: 450px;
  width: 250px;
  border-radius: 70px 70px 0 0;
  background-color: #A0AEC0;
  position: relative;
`;

const Window = styled.div`
  height: 40px;
  width: 130px;
  background-color: #1C2127;
  border-radius: 3px;
  margin: 80px auto;
  position: relative;
`;

const Eye = styled.div`
  top: 15px;
  left: 25px;
  height: 5px;
  width: 15px;
  border-radius: 50%;
  background-color: white;
  animation: ${eye} 7s ease-in-out infinite;
  position: absolute;
  &:nth-child(2) {
    left: 65px;
  }
`;

const Leaf = styled.div`
  height: 40px;
  width: 130px;
  background-color: #8594A5;
  border-radius: 3px;
  margin: 80px auto;
  animation: ${leaf} 7s infinite;
  transform-origin: right;
`;

const Handle = styled.div`
  height: 8px;
  width: 50px;
  border-radius: 4px;
  background-color: #EBF3FC;
  position: absolute;
  bottom: 195px;
  left: 30px;
`;

const Rectangle = styled.div`
  height: 70px;
  width: 25px;
  background-color: #CBD8E6;
  border-radius: 4px;
  position: absolute;
  bottom: 165px;
  left: 20px;
`;

const Unauthorized = () => {
  return (
    <Wrapper>
      <Message>You are not authorized.</Message>
      <Message2>You tried to access a page you did not have prior authorization for.</Message2>
      <Message3>Unexpected? Please contact Admin Support</Message3>
      <Container>
        <Neon>Intruder!</Neon>
        <DoorFrame>
          <Door>
            <Rectangle />
            <Handle />
            <Window>
              <Eye />
              <Eye />
              <Leaf />
            </Window>
          </Door>
        </DoorFrame>
      </Container>
    </Wrapper>
  );
};

export default Unauthorized;